import { render } from "./WardanTell.vue?vue&type=template&id=1137ef28"
import script from "./WardanTell.vue?vue&type=script&lang=ts"
export * from "./WardanTell.vue?vue&type=script&lang=ts"

import "./WardanTell.vue?vue&type=style&index=0&id=1137ef28&lang=css"
script.render = render

export default script